import React, { Key, useEffect, useState } from 'react'
import './Plp.scss'
import { CreateRequest } from '../../Components'
import { HorizontalLoader, ModalWrapper } from '../../../../Components'
import plpService from '../../../../Services/plpService'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { plpType } from '../../../../Models/plpType'
import { TimeConverter } from 'Helpers/TimeConverter'
import { Pagination } from 'Components'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import Swal from 'sweetalert2'
import ProductLease from './ProductLease/ProductLease'

const Plp = () => {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const navigate = useNavigate()

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }
  const [pageNumber, setPage] = useState(1)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortOrder, setSortOrder] = useState('DESC')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [status, setStatus] = useState('ALL')
  const [isSuspended, setIsSuspended] = useState<boolean | undefined>(undefined)

  const [plp, setPlp] = useState<plpType[]>([])
  const [loading, setLoading] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getOrders = async () => {
    setLoading(true)
    await plpService.index(pageNumber, sortOrder, status, isSuspended).then(
      (response) => {
        setLoading(false)
        setPlp(response?.data.data.dataset)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getOrders()
  }, [pageNumber, sortOrder, status, isSuspended])

  const [aprovalReq, setAprovalReq] = useState(false)

  const { showAlert } = ShowTGAlert()

  const [reasonModal, setReasonModal] = useState(false)
  const [ID, setID] = useState<string>()
  const toggleReasonModal = () => setReasonModal(!reasonModal)

  const toggleSuspension = async (referenceId: string) => {
    setID(referenceId)
    setAprovalReq(true)
    await plpService.toggleSuspension(referenceId).then(
      (response) => {
        setAprovalReq(false)
        showAlert({
          message: 'Traders Card status saved successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })

        setTimeout(() => {
          getOrders()
        }, 2000)
      },
      (error: { response: { data: { error: string } } }) => {
        setAprovalReq(false)

        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
  }

  const exportPLP = async (docType: string) => {
    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)

    Swal.fire({
      text: 'Exporting, please wait a moment.',
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await plpService.exportPLP(sortOrder, status).then(
      (response) => {
        const streamedData = new Blob([response.data], { type: docType })
        const streamedUrl = window.URL.createObjectURL(streamedData)

        a.href = streamedUrl
        a.download = 'traders_card.' + (docType === 'text/csv' ? 'csv' : 'doc')
        a.click()
        window.URL.revokeObjectURL(streamedUrl)
        Swal.close()
      },
      (error) => {
        Swal.close()
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  return (
    <div className='Plp'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='head-tab'>
            <ul className='nav nav-pills mb-3' id='pills-tab' role='tablist'>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${tab === 'applications' ? 'active' : ''}`}
                  id='pills-home-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-home'
                  type='button'
                  role='tab'
                  aria-controls='pills-home'
                  aria-selected='true'
                  onClick={() => {
                    navigate('/plp?tab=applications')
                  }}
                >
                  Applications
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${tab === 'productlease' ? 'active' : ''}`}
                  id='pills-profile-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-profile'
                  type='button'
                  role='tab'
                  aria-controls='pills-profile'
                  aria-selected='false'
                  onClick={() => {
                    navigate('/plp?tab=productlease')
                  }}
                >
                  Product Lease
                </button>
              </li>
            </ul>
          </div>

          {tab === 'applications' && (
            <div className='card border-0'>
              <div className='card-header border-0 px-0'>
                <div className='row'>
                  <div className='col-6 col-md-6 my-auto'>
                    <div className='title'></div>
                  </div>
                  <div className='col-12 col-md-6 text-end'>
                    <Link to={'/plp/create'}>
                      <button className='btn btn-add-company' onClick={toggleModal}>
                        Create Traders Card Application for customer
                      </button>
                    </Link>
                  </div>
                </div>
                <div className='row mt-2'>
                  <div className='col-12 col-md-8'>
                    <div className='search-field'>
                      <span>
                        <svg
                          width='18'
                          height='18'
                          viewBox='0 0 18 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M11.675 11.5661C9.34155 13.8995 5.55835 13.8995 3.22493 11.5661C0.891523 9.23269 0.891523 5.44948 3.22493 3.11607C5.55835 0.782656 9.34156 0.782656 11.675 3.11607C14.0084 5.44948 14.0084 9.23269 11.675 11.5661ZM11.675 11.5661L16.4126 16.3037'
                            stroke='#868484'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                          />
                        </svg>
                      </span>

                      <input
                        type='text'
                        className='form-control'
                        placeholder='Search Traders Card No or User'
                      />
                    </div>
                  </div>
                  <div className='col-6 col-md-2 dropdown'>
                    <button
                      className='btn btn-filter dropdown-toggle'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <svg
                        width='17'
                        height='17'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.02001C3.13002 8.39001 2.65002 7.31001 2.65002 6.50001V4.20001C2.65002 2.60001 3.86002 1.35001 5.40002 1.35001H18.6C20.12 1.35001 21.35 2.58001 21.35 4.10001V6.30001C21.35 7.35001 20.72 8.54001 20.13 9.13001L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.85001C4.70002 2.85001 4.15002 3.44001 4.15002 4.20001V6.50001C4.15002 6.87001 4.45002 7.59001 4.83002 7.97001L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.03001C19.45 7.69001 19.86 6.88001 19.86 6.29001V4.10001C19.86 3.41001 19.3 2.85001 18.61 2.85001H5.40002Z'
                          fill='#868484'
                        />
                        <path
                          d='M6.00004 10.75C5.86004 10.75 5.73004 10.71 5.60004 10.64C5.25004 10.42 5.14004 9.94999 5.36004 9.59999L10.29 1.69999C10.51 1.34999 10.97 1.23999 11.32 1.45999C11.67 1.67999 11.78 2.13999 11.56 2.48999L6.63004 10.39C6.49004 10.62 6.25004 10.75 6.00004 10.75Z'
                          fill='#868484'
                        />
                      </svg>
                      Filters
                    </button>
                    <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                      <div className='dropdown-item'>
                        <form action=''>
                          <div className='form-group'>
                            <label htmlFor=''>Status</label>
                            <select
                              id=''
                              className='form-control'
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <option>ALL</option>
                              <option>PENDING_APPROVAL</option>
                              <option>APPROVED</option>
                              <option>REJECTED</option>
                            </select>
                          </div>
                          <div className='form-group mt-3'>
                            <label htmlFor=''>Status</label>
                            <select
                              id=''
                              className='form-control'
                              onChange={(e) => setSortOrder(e.target.value)}
                            >
                              <option>DESC</option>
                              <option>ASC</option>
                            </select>
                          </div>

                          <div className='form-group mt-3'>
                            <label htmlFor=''>Suspended</label>
                            <select
                              className='form-control'
                              onChange={(e) => {
                                setIsSuspended(
                                  e.target.value === 'YES'
                                    ? true
                                    : e.target.value === 'NO'
                                      ? false
                                      : undefined,
                                )
                              }}
                            >
                              <option value='ALL'>All</option>
                              <option value='YES'>Yes</option>
                              <option value='NO'>No</option>
                            </select>
                          </div>

                          <div className='row mt-3'>
                            <div className='col-md-6'>
                              <button className='btn btn-reset' type='button'>
                                Reset
                              </button>
                            </div>
                            <div className='col-md-6 text-end'>
                              <button className='btn btn-filter' type='button'>
                                Filter
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className='col-6 col-md-2 dropdown'>
                    <button
                      className='btn btn-export dropdown-toggle'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <svg
                        width='17'
                        height='17'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9 11V17L11 15'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M9 17L7 15'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M22 10H18C15 10 14 9 14 6V2L22 10Z'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>{' '}
                      Export
                    </button>

                    <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                      <li className='dropdown-item' onClick={() => exportPLP('text/csv')}>
                        Export as .csv
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='card-body'>
                <div className='tab-content mt-4'>
                  <div className='table-responsive'>
                    <table className='table'>
                      <thead>
                        <tr>
                          <td>Company Name</td>
                          <td>User</td>
                          <td>Phone Number</td>
                          <td>Status</td>
                          {/* <td>Active Status</td> */}
                          {/* <td>L.A Status</td> */}
                          <td>Date Created</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {plp.length > 0 &&
                          plp.map((data: plpType, index: Key) => (
                            <tr key={index}>
                              <td>#{data.companyName}</td>
                              <td>
                                {data.customer.firstName} {data.customer.lastName}
                              </td>
                              <td>{data.customer.msisdn}</td>
                              <td className='text-'>
                                {data.plpApplicationVerified === 'REJECTED' && (
                                  <span className='status fw-bolder rejected'>
                                    {data.plpApplicationVerified}
                                  </span>
                                )}
                                {data.plpApplicationVerified === 'PENDING_APPROVAL' && (
                                  <span className='status fw-bolder pending'>
                                    {data.plpApplicationVerified}
                                  </span>
                                )}
                                {data.plpApplicationVerified === 'APPROVED' && (
                                  <span className='status fw-bolder approved'>
                                    {data.plpApplicationVerified}
                                  </span>
                                )}
                              </td>
                              {/* <td className='text-'>
                            {data.isSuspended === true ? (
                              <span className='status fw-bolder'>Suspended</span>
                            ) : (
                              <span className='active fw-bolder'>Active</span>
                            )}
                          </td> */}
                              {/* <td>-</td> */}
                              <td>{TimeConverter(data.createdAtISO8601)}</td>
                              <td className='dropdown option-dropdown'>
                                <button
                                  className='btn border-0 dropdown-toggle'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                  data-bs-popper-config='{"strategy":"fixed"}'
                                >
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                      fill='#707070'
                                    />
                                  </svg>
                                </button>

                                <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                                  <Link
                                    to={`/plp/detail/${data.id}`}
                                    className='text-decoration-none'
                                  >
                                    <li className='dropdown-item'>View Details</li>
                                  </Link>

                                  <Link
                                    to={`/traders-card/${data.id}`}
                                    className='text-decoration-none'
                                  >
                                    <li className='dropdown-item'>Lease Asset Details</li>
                                  </Link>

                                  {/* <li className='dropdown-item'><Link to={`/plp/${data.id}`}>Track PLP</Link></li> */}
                                  <li
                                    className='dropdown-item text-danger'
                                    onClick={() =>
                                      confirm(
                                        `Are you sure you want to ${data.isSuspended === true ? 'Unsuspend' : 'Suspend'} this TradersCard?`,
                                      ) === true
                                        ? toggleSuspension(data.id)
                                        : false
                                    }
                                  >
                                    {data.isSuspended === true ? 'Unsuspend' : 'Suspend'}
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}

                        {loading === false && plp.length === 0 && (
                          <tr>
                            <td colSpan={8} className='text-center'>
                              No Traders Card application found
                            </td>
                          </tr>
                        )}
                        {loading === true && plp.length === 0 && (
                          <tr>
                            <td colSpan={8} className='text-center'>
                              <HorizontalLoader></HorizontalLoader>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {paginationData.total >= paginationData.pageSize && (
                    <div className='pagination w-100 d-flex justify-content-center'>
                      {paginationData.total && (
                        <Pagination
                          className='pagination-bar ps-0'
                          currentPage={Number(paginationData.pageNumber)}
                          totalCount={paginationData.total}
                          pageSize={paginationData.pageSize}
                          onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {tab === 'productlease' && <ProductLease></ProductLease>}
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Create Request'>
        <CreateRequest toggleModal={toggleModal}></CreateRequest>
      </ModalWrapper>

      <ModalWrapper
        showModal={reasonModal}
        closeModal={toggleReasonModal}
        title='Reason for cancellation'
      >
        <form>
          <div className='form-input'>
            <textarea name='' id=''></textarea>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default Plp
